import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
// material-ui components
import { Typography } from '@mui/material';

const OutOfOfficeSummary = ({ items, t }) =>
  items && (
    <div>
      <Typography variant='h6'>{t('User.OutOfOffice.Summary.Title')}</Typography>
      <Typography>
        {items.length} {t('User.OutOfOffice.Summary.Items')}
      </Typography>
    </div>
  );

OutOfOfficeSummary.propTypes = {
  items: PropTypes.array.isRequired,
  t: PropTypes.func.isRequired
};

export default withTranslation()(OutOfOfficeSummary);
